import type { Options } from 'html2canvas'
import { useState } from 'react'

import { ImageType } from '@/types/enums'

type UseDomToBase64 = {
  isConverting: boolean
  getStringContext: (options?: Partial<Options>) => Promise<string | void>
}

const useDomToBase64 = (
  node: HTMLElement | null,
  type: ImageType = ImageType.PNG
): UseDomToBase64 => {
  const [isConverting, setIsConverting] = useState<boolean>(false)

  const getStringContext = (options?: Partial<Options>) => {
    if (!node) {
      setIsConverting(false)
      return Promise.resolve('')
    }

    if (!isConverting) {
      setIsConverting(true)

      // html2canvas весит ~400 KB и нужен только в момент экспорта,
      // поэтому грузим его отдельным чанком по требованию. OCT-4846
      return import('html2canvas')
        .then(({ default: html2canvas }) => html2canvas(node, options))
        .then((canvas) => {
          setIsConverting(false)

          return canvas.toDataURL(type)
        })
        .catch((err) => {
          console.error(err)
          setIsConverting(false)
        })
    }

    return Promise.resolve('')
  }

  return { getStringContext, isConverting }
}

export default useDomToBase64
